import React from 'react';
import { useTranslation } from 'react-i18next';
import './ThroughYourEyes.scss';

const ThroughYourEyes = () => {
  const { t } = useTranslation();

  return (
    <section className="through-eyes">
      <div className="through-eyes__container">
        <h2 className="through-eyes__title">
          <span className="through-eyes__title--orange">{t('throughYourEyes.titleHighlight')}</span>{' '}
          {t('throughYourEyes.titleMain')}
        </h2>
      </div>

      <div className="through-eyes__slider-container">
        <rssapp-carousel id="e8lWt2KHrJOQcEI7"></rssapp-carousel>
      </div>
    </section>
  );
};

export default ThroughYourEyes;
